module.exports = __webpack_public_path__ + "img/icon_title01@2x.72f4edfe.png";